import PropTypes from 'prop-types';
import React from 'react';

import { WaybillFilterQueryShape } from 'shapes/waybills';
import { gettext } from '../../utils/text';
import { FILTERS } from '../../ducks/filters';
import TableEntityFilter from '../Table/TableEntityFilter';

const WaybillOriginFilter = ({ originName, changeOriginName, query }) => {
    return (
        <TableEntityFilter
            initialValue={originName}
            onChange={changeOriginName}
            itemsToOptions={item => ({
                text: item,
                value: item,
            })}
            name="origin_filter"
            buttonPlaceholder={gettext('Select origin')}
            buttonLeftIcon="map-marker"
            filterType={FILTERS.WAYBILL.ORIGINS}
            query={query}
        />
    );
};

WaybillOriginFilter.propTypes = {
    originName: PropTypes.string.isRequired,
    changeOriginName: PropTypes.func.isRequired,
    query: WaybillFilterQueryShape.isRequired,
};

export default WaybillOriginFilter;
